// trigger build
import OwlCarousel from 'react-owl-carousel';

const internals = {};
const { Component } = window.React;

internals.sliderOptions = {
  className: 'owl-theme ig-slider',
  touchDrag: true,
  mouseDrag: true,
  nav: true,
  lazyLoad: true,
  items: 1
};

export default class Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startPosition: 0,
      activePosition: 'left'
    };
  }

  componentDidMount = () => {
    this.setInstagramDots();
  }

  componentDidUpdate = () => {
    this.setInstagramDots();
  }

  setInstagramDots = () => {
    const {resortSummary: {rstCode}} = this.props;
    let {activePosition} = this.state;
    const slider = $(`.${rstCode} .ig-slider`);
    const dot = slider.find('.owl-dots .owl-dot.active');
    const dotSize1 = 'dot-size-1';
    const dotSize2 = 'dot-size-2';
    const dotSize3 = 'dot-size-3';
    const removeDots = () => {
      slider.find('.owl-dots .owl-dot').each((i, currentDot) => {
        currentDot.classList.remove(dotSize1);
        currentDot.classList.remove(dotSize2);
        currentDot.classList.remove(dotSize3);
        currentDot.disabled = true;
      });
    };

    if(dot.hasClass(dotSize3) || dot.hasClass(dotSize2)) {
      if(dot.next().length === 0 || dot.next().hasClass(dotSize2) || dot.next().hasClass(dotSize1)) {
        activePosition = 'right';
      } else if(dot.prev().length === 0 || dot.prev().hasClass(dotSize2) || dot.prev().hasClass(dotSize1)) {
        activePosition = 'left';
      } else {
        activePosition = 'middle';
      }
    }

    removeDots();
    if(activePosition === 'left') {
      dot.prev().prev().addClass(dotSize1);
      dot.prev().addClass(dotSize2);
      dot.addClass(dotSize3);
      dot.next().addClass(dotSize3);
      dot.next().next().addClass(dotSize3);
      dot.next().next().next().addClass(dotSize2);
      dot.next().next().next().next().addClass(dotSize1);
    } else if(activePosition === 'middle') {
      dot.prev().prev().prev().addClass(dotSize1);
      dot.prev().prev().addClass(dotSize2);
      dot.prev().addClass(dotSize3);
      dot.addClass(dotSize3);
      dot.next().addClass(dotSize3);
      dot.next().next().addClass(dotSize2);
      dot.next().next().next().addClass(dotSize1);
    } else {
      dot.prev().prev().prev().prev().addClass(dotSize1);
      dot.prev().prev().prev().addClass(dotSize2);
      dot.prev().prev().addClass(dotSize3);
      dot.prev().addClass(dotSize3);
      dot.addClass(dotSize3);
      dot.next().addClass(dotSize2);
      dot.next().next().addClass(dotSize1);
    }

    if(activePosition !== this.state.activePosition) {
      this.setState({activePosition});
    }
  }

  updateCarouselPosition = (e) => {
    this.setInstagramDots();
    if(e.item.index !== this.state.startPosition) {
      this.setState({ startPosition: e.item.index });
    }
  }

  getImages = () => {
    const arr = [];
    const {cdnURL, resortSummary: {rstCode}} = this.props;

    for (let i = 1; i <= this.props.sliderData[rstCode]; i++) {
      arr.push(
        <img
          alt=""
          data-src={`${cdnURL}/specials/slider/${rstCode.toLowerCase()}/thumb-${i}.jpg`}
          key={`image-${i}`}
          className="owl-lazy"
        />
      );
    }

    return arr;
  }

  render() {
    const {resortSummary: {rstCode}} = this.props;

    return (
      <div className={rstCode}>
        <OwlCarousel startPosition={this.state.startPosition} onTranslated={(e) => this.updateCarouselPosition(e)} {...internals.sliderOptions}>
          {this.getImages()}
        </OwlCarousel>
      </div>
    );
  }
}
